export default {
  toasts: {
    load_error: 'Fakturaerne kunne ikke indlæses.',
    action_error: 'Handlingen mislykkedes – prøv igen.',
    finalized: 'Faktura færdiggjort.',
    marked_paid: 'Faktura markeret som betalt.',
  },
  filters: {
    status: 'Filtrer efter status',
  },
  volume_discount_badge: 'Mængderabat anvendt ({{licenses}} licenser, {{percent}} %)',
  columns: {
    description: 'Faktura',
    status: 'Status',
    total: 'I alt',
    paid_at: 'Betalt den',
  },
  statuses: {
    pending: 'Afventer',
    processing: 'Behandles',
    paid: 'Betalt',
    failed: 'Mislykket',
    refunded: 'Refunderet',
    partially_refunded: 'Delvist refunderet',
  },
  companies: {
    partner_level: 'Justeringer på partnerniveau',
    columns: {
      company: 'Restaurant',
      buckets: 'Poster',
      amount: 'Beløb',
    },
  },
  buckets: {
    license_fees: 'Licensgebyrer',
    service_fees: 'Servicegebyrer',
    processing_fees: 'Behandlingsgebyrer',
    delivery_fees: 'Leveringsgebyrer',
    gift_card_fees: 'Gavekortgebyrer',
    adjustments: 'Justeringer',
  },
  entries: {
    count: '{{count}} poster',
    columns: {
      description: 'Post',
      occurred_at: 'Dato',
      amount: 'Beløb',
    },
  },
  incl_tax: 'inkl. {{amount}} moms',
  actions: {
    open_invoice_pdf: 'Download faktura (PDF)',
    open_hosted: 'Åbn faktura på Stripe',
    export_csv: 'Eksporter CSV',
    finalize: 'Færdiggør på Stripe',
    mark_paid: 'Markér som betalt',
  },
  finalize: {
    title: 'Færdiggøre denne faktura på Stripe?',
    description:
      'Færdiggørelsen starter opkrævningen: Med en gemt betalingsmetode gennemføres betalingen automatisk, ellers modtager partneren den hostede faktura.',
    confirm: 'Færdiggør',
  },
  mark_paid: {
    pushed_note:
      'Denne faktura ligger allerede på Stripe — kladden slettes (eller en færdiggjort faktura markeres som betalt uden for Stripe), så Stripe holder op med at opkræve.',
    title: 'Markere denne faktura som betalt?',
    description:
      'Registrerer en manuel (offline) betaling på {{amount}}. Brug dette til bankoverførsler, der er modtaget uden for Stripe.',
    confirm: 'Markér som betalt',
  },
  settlement_badge: {
    paid: 'Omsætningsandel udbetalt: {{amount}}',
    other: 'Udbetaling af omsætningsandel {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Udbetalinger af omsætningsandel',
    retry: 'Prøv igen',
    toasts: {
      load_error: 'Udbetalingerne kunne ikke indlæses.',
      retry_error: 'Det nye forsøg mislykkedes — prøv igen.',
      retry_paid: 'Omsætningsandel udbetalt.',
      retry_attempted: 'Det nye forsøg blev kørt — udbetalingen er endnu ikke gennemført, tjek dens status.',
    },
    columns: {
      period: 'Periode',
      amount: 'Beløb',
      status: 'Status',
      transfer: 'Overførsel',
      paid_at: 'Betalt den',
      payout: 'Udbetaling',
    },
    payout: {
      direct: '{{amount}}, ingen konvertering',
      direct_tooltip:
        'Skyldigt beløb {{owed}}, konverteret til kursen 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} og sendt uændret: ingen Stripe-konvertering, intet gebyr.',
      converted: 'Sendt {{sent}} → modtaget {{arrived}}',
      expected: 'Sendt {{sent}} → forventet {{arrived}}',
      fee: 'Stripe-konverteringsgebyr {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'Gebyr og nettobeløb vises, når Stripe har afsluttet overførslen.',
      tooltip:
        'Skyldigt beløb {{owed}}. Konverteret til kursen 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, sendt fra platformens saldo i {{source_currency}} og konverteret af Stripe til kursen 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe fratrækker {{fee_rate}} % ved modtagelsen.',
    },
    statuses: {
      pending: 'Afventer',
      held: 'Tilbageholdt',
      processing: 'Behandles',
      paid: 'Udbetalt',
      failed: 'Mislykket',
      reversed: 'Tilbageført',
    },
    hold_reasons: {
      kyc_incomplete: 'Partneren har endnu ikke gennemført verificeringen af udbetalingskontoen.',
      transfers_inactive: 'Udbetalingskontoen kan endnu ikke modtage overførsler.',
      insufficient_platform_balance: 'Platformens saldo kan ikke dække denne udbetaling lige nu.',
      manual_hold: 'Tilbageholdt manuelt.',
      missing_fx_rate: 'Der er endnu ikke gemt nogen valutakurs for udbetalingsvalutaen. Der prøves automatisk igen.',
      unsupported_payout_currency: 'Stripe kan ikke udbetale til udbetalingskontoens valuta fra platformens saldo.',
      amount_too_small: 'Det skyldige beløb er under Stripes mindstebeløb for overførsler i denne valuta.',
    },
  },
};
